import React from 'react';
import {
  GridToolbarContainer,
  useGridApiContext,
  GridPreferencePanelsValue,
} from '@mui/x-data-grid-pro';
import { Box, Button } from '@mui/material';
import { Columns as ColumnsIcon } from 'react-feather';

interface AdminToolbarProps {
  setToolbarButtonEl: React.Dispatch<
    React.SetStateAction<HTMLButtonElement | null>
  >;
  renderDownloadButton?: () => React.ReactNode;
  renderSearchBar?: () => React.ReactNode;
  renderTitle?: () => React.ReactNode;
  visibility?: boolean;
}

export const AdminToolbar = ({
  visibility = true,
  setToolbarButtonEl,
  renderDownloadButton,
  renderSearchBar,
  renderTitle,
}: AdminToolbarProps) => {
  const apiRef = useGridApiContext();

  return (
    <GridToolbarContainer
      sx={{
        padding: '16px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '12px',
      }}
    >
      {renderTitle && <Box sx={{ flex: 1 }}>{renderTitle()}</Box>}

      {visibility && (
        <Button
          onClick={() => {
            apiRef.current.showPreferences(GridPreferencePanelsValue.columns);
          }}
          variant="outlined"
          sx={{
            borderColor: 'rgba(59, 57, 108, 0.15)',
          }}
          startIcon={<ColumnsIcon height={20} width={20} />}
          ref={setToolbarButtonEl}
        >
          Columns
        </Button>
      )}
      {renderSearchBar && (
        <Box
          sx={{
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
          }}
        >
          {renderSearchBar()}
        </Box>
      )}
      {renderDownloadButton && (
        <Box sx={{ display: 'flex', gap: '8px' }}>{renderDownloadButton()}</Box>
      )}
    </GridToolbarContainer>
  );
};
